import PropTypes from 'prop-types'
import React from 'react'

const ImageContainer = ({ imageUrl, divClassName, children }) => (
  <div
    className={divClassName + ' full-width-image-container relative'}
    style={{ backgroundImage: `url(${imageUrl})` }}
  >
    {children}
  </div>
)

ImageContainer.propTypes = {
  imageUrl: PropTypes.string.isRequired,
}

export default ImageContainer
